export interface MatrixSettingsInterface
  extends MatrixSettingsRequestInterface {
  id: number;
}

export enum ReportDefaultCodeEnum {
  DEFAULT_CODE = 'DEFAULT_CODE',
  ITEM_DESCRIPTION = 'ITEM_DESCRIPTION',
  INSERTION_ORDER = 'INSERTION_ORDER',
}

export interface MatrixSettingsRequestInterface {
  reportAnnotations: boolean;
  reportCustomerInfo: boolean;
  reportSorting: ReportDefaultCodeEnum;
  reportDefaultValue: boolean;
}
